module.exports = __webpack_public_path__ + "img/73.fe36453d.png";